Ext.define('SA.view.VideoWindow', {
    alias: 'widget.video-window',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-video-window',
    floating: true,

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-video-window-body',
            itemId: 'body',

            items: [
                {
                    xtype: 'close-button'
                }, {
                    xtype: 'component',
                    html: '<iframe class="sa-video-window-iframe" src="https://player.vimeo.com/video/222679318?autoplay=1" allowfullscreen></iframe>'
                }
            ]
        }
    ],

    afterRender() {
        this.callParent();

        this.body = this.down('#body');
        this.iframe = this.el.query('.sa-video-window-iframe')[0];
    },

    afterShow() {
        this.callParent();

        this.refreshSizeAndCenter();
    },

    beforeDestroy() {
        this.callParent();

        this.mun(SA.Viewport, 'resize', this.refreshSizeAndCenter, this);
    },

    initEvents() {
        this.callParent();

        this.mon(SA.Viewport, 'resize', this.refreshSizeAndCenter, this);
    },

    refreshSizeAndCenter() {
        var iframe = this.iframe,
            aspectRatio = 13 / 24,
            bodyEl = this.body,
            docBody = Ext.getBody(),
            El = Ext.dom.Element,
            constrain = Ext.Number.constrain,
            minHeight = 300,
            maxHeight = 800,
            width = constrain(El.getViewportWidth() - 60, minHeight / aspectRatio, maxHeight / aspectRatio),
            height = constrain(El.getViewportHeight() - 120, minHeight, maxHeight),
            size = SA.restrictSizeByRatio({height, width}, aspectRatio),
            xy;

        Ext.fly(iframe).setSize(size);

        xy = bodyEl.getAlignToXY(docBody, 'c-c?');

        bodyEl.setPagePosition(xy);
    }
});
